import React, { type Ref, useImperativeHandle, useRef } from "react";
import HandleDragAndDrop from "./HandleDragAndDrop";

type Props = {
    dragAndDropLabel: string;
    children: React.ReactNode;
    className?: string;
    multiple?: boolean;
    accept?: string;
    onUpload: (files: FileList | null) => void;
};

export type Actions = {
    triggerFileUpload: () => void;
};

const HandleFileUpload = React.forwardRef((props: Props, refs: Ref<Actions>) => {
    const {
        dragAndDropLabel,
        children,
        multiple = true,
        accept,
        className,
        onUpload,
    } = props;
    const uploadInputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(refs, () => ({
        triggerFileUpload: () => uploadInputRef.current?.click(),
    }));

    return (
        <HandleDragAndDrop
            label={dragAndDropLabel}
            onDropFiles={(files) => {
                onUpload(files);
            }}
            onClick={() => uploadInputRef.current?.click()}
            className={className}
        >
            <input
                type="file"
                id="file"
                ref={uploadInputRef}
                style={{ display: "none" }}
                onChange={(event) => {
                    onUpload(event.target.files);
                    event.target.value = "";
                }}
                accept={accept}
                multiple={multiple}
            />
            {children}
        </HandleDragAndDrop>
    );
});

export default HandleFileUpload;
